import React from "react";
import { jsPDF } from "jspdf";
import { Button } from "@mui/material";
import logo from "../../../../Assests/cosmos  Logo.png";
import Paidlogo from "../../../../Assests/paid logo.png";

const InvoiceGenerator = ({ services, products, patientData, Billdata }) => {
  const generatePDF = () => {
    const doc = new jsPDF();
    const logoX = 20;
    const logoY = 20;
    const logoWidth = 50;
    const logoHeight = 20;
    const margin = 20;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const textStartX = logoX + logoWidth + margin;

    doc.setFontSize(12);
    doc.text(
      "4317 E 3rd St, Bloomington, IN 47401, United States",
      textStartX,
      logoY + 5,
      { align: "left" }
    );
    doc.text("Contact: 812-803-0079", textStartX, logoY + 10, {
      align: "left",
    });
    doc.text("Email: info@medispacosmos.com", textStartX, logoY + 15, {
      align: "left",
    });

    const isBilled = Billdata[0]?.is_billed === 1
    doc.setFontSize(16);
    doc.text(isBilled ? "Receipt" : "Invoice", 20, logoY + logoHeight + 10);

    const tableStartX = 20;
    let tableY = logoY + logoHeight + 20;
    const rowHeight = 10;
    const padding = 2;
    const columnWidths = [60, 60, 60];

    doc.setFillColor(220, 220, 220);
    const tableWidth = columnWidths.reduce((a, b) => a + b, 0);
    doc.rect(tableStartX, tableY, tableWidth, rowHeight * 3, "F");

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    const patientRow = [
      `Name: ${patientData.patient_fname} ${patientData.patient_lname}`,
      `${patientData.patient_email}`,
      `Contact: ${patientData.patient_contact}`,
    ];

    patientRow.forEach((text, index) => {
      doc.text(
        text,
        tableStartX +
          padding +
          columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
        tableY + rowHeight / 2
      );
    });

    doc.rect(tableStartX, tableY, tableWidth, rowHeight);

    tableY += rowHeight;
    const appointmentRow = [
      `Appointment ID: ${Billdata[0]?.eid}`,
      `Date: ${patientData?.pc_eventDate}`,
      `Time: ${patientData?.pc_startTime}`,
    ];

    appointmentRow.forEach((text, index) => {
      doc.text(
        text,
        tableStartX +
          padding +
          columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
        tableY + rowHeight / 2
      );
    });

    doc.rect(tableStartX, tableY, tableWidth, rowHeight);

    tableY += rowHeight;
    const providerRow = [
      `Bill ID: ${Billdata[0]?.bill_id}`,
      `Provider: ${patientData.provider_fname} ${patientData.provider_lname}`,
    ];

    providerRow.forEach((text, index) => {
      doc.text(
        text,
        tableStartX +
          padding +
          columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
        tableY + rowHeight / 2
      );
    });

    doc.rect(tableStartX, tableY, tableWidth, rowHeight);

    const headers = ["Title", "Price", "Quantity", "Discount", "Total Amount"];
    const headerX = 20;
    let y = tableY + 20;
    const cellHeight = 10;
    const cellPadding = 2;
    const colWidths = [80, 20, 20, 20, 40];

    doc.setFontSize(12);
    if (services.length > 0){

    
    doc.text("Services:", 20, y);
    y += 10;

    headers.forEach((header, i) => {
      doc.text(
        header,
        headerX +
          colWidths.slice(0, i).reduce((a, b) => a + b, 0) +
          cellPadding,
        y
      );
      doc.rect(
        headerX + colWidths.slice(0, i).reduce((a, b) => a + b, 0),
        y - cellHeight + 3,
        colWidths[i],
        cellHeight
      );
    });

    y += cellHeight;

    services.forEach((service) => {
      const serviceTitleLines = doc.splitTextToSize(
        service.service_title,
        colWidths[0] - 2 * cellPadding
      );
      const rowHeight = cellHeight * serviceTitleLines.length;

      serviceTitleLines.forEach((line, i) => {
        doc.text(line, headerX + cellPadding, y + i * cellHeight);
      });
      doc.text(
        `$${service.service_default_price.toString()}`,
        headerX + colWidths[0] + cellPadding,
        y
      );
      doc.text(
        service.service_quantity.toString(),
        headerX + colWidths[0] + colWidths[1] + cellPadding,
        y
      );
      doc.text(
        `${service.service_discount.toString()}%`,
        headerX + colWidths[0] + colWidths[1] + colWidths[2] + cellPadding,
        y
      );
      doc.text(
        `$${service.service_total_amount.toString()}`,
        headerX +
          colWidths[0] +
          colWidths[1] +
          colWidths[2] +
          colWidths[3] +
          cellPadding,
        y
      );

      headers.forEach((header, i) => {
        doc.rect(
          headerX + colWidths.slice(0, i).reduce((a, b) => a + b, 0),
          y - cellHeight + 3,
          colWidths[i],
          rowHeight
        );
      });
      y += rowHeight;
    });
  }
    y += cellHeight;

    doc.setFontSize(12);
    if (products.length > 0){

    
    doc.text("Products:", 20, y);
    y += 10;

    headers.forEach((header, i) => {
      doc.text(
        header,
        headerX +
          colWidths.slice(0, i).reduce((a, b) => a + b, 0) +
          cellPadding,
        y
      );
      doc.rect(
        headerX + colWidths.slice(0, i).reduce((a, b) => a + b, 0),
        y - cellHeight + 3,
        colWidths[i],
        cellHeight
      );
    });

    y += cellHeight;

    products.forEach((product) => {
      const productTitleLines = doc.splitTextToSize(
        product.product_title,
        colWidths[0] - 2 * cellPadding
      );
      const rowHeight = cellHeight * productTitleLines.length;

      productTitleLines.forEach((line, i) => {
        doc.text(line, headerX + cellPadding, y + i * cellHeight);
      });
      doc.text(
        `$${product.product_default_price.toString()}`,
        headerX + colWidths[0] + cellPadding,
        y
      );
      doc.text(
        product.product_quantity.toString(),
        headerX + colWidths[0] + colWidths[1] + cellPadding,
        y
      );
      doc.text(
        `${product.product_discount.toString()}%`,
        headerX + colWidths[0] + colWidths[1] + colWidths[2] + cellPadding,
        y
      );
      doc.text(
        `$${product.product_total_amount.toString()}`,
        headerX +
          colWidths[0] +
          colWidths[1] +
          colWidths[2] +
          colWidths[3] +
          cellPadding,
        y
      );

      headers.forEach((header, i) => {
        doc.rect(
          headerX + colWidths.slice(0, i).reduce((a, b) => a + b, 0),
          y - cellHeight + 3,
          colWidths[i],
          rowHeight
        );
      });
      y += rowHeight;
    });
  }
    const subtotalText = `Subtotal: $${Billdata[0]?.amount_after_tip.toString()}`;
    const subtotalWidth = doc.getTextWidth(subtotalText);
    const subtotalX = pageWidth - margin - subtotalWidth;
    doc.text(subtotalText, subtotalX, pageHeight - 20);

    const subtotalY = y + 50;

    doc.setFontSize(12);

    const logoWidthPaid = 40;
    const logoHeightPaid = 40;
    // const logoXPaid = pageWidth - margin - logoWidthPaid;
    // const logoYPaid = subtotalY - logoHeightPaid;

    // Add Paidlogo image
    if (isBilled){
    doc.addImage(
      Paidlogo,
      "PNG",
      subtotalX,
      pageHeight - 60,
      logoWidthPaid,
      logoHeightPaid
    );}
    doc.text(subtotalText, subtotalX, pageHeight - 20);
    const patientName = `${patientData.patient_fname}_${patientData.patient_lname}`;
    const billId = Billdata[0]?.bill_id || "N/A";
    const pdfType = isBilled ? "Receipt" : "Invoice";
    const fileName = `Cosmos_Appointment_${pdfType}_${patientName}_${billId}.pdf`;

    doc.save(fileName);
  };
  const isBilledBill = Billdata[0]?.is_billed === 1
  return (
    <Button onClick={generatePDF} variant="contained" color="primary" className="mt-5">
      Download {isBilledBill ? "Receipt" : "Invoice"}
    </Button>
  );
};

export default InvoiceGenerator;
